import { render } from "./GameModal.vue?vue&type=template&id=76c0a05c"
import script from "./GameModal.vue?vue&type=script&lang=js"
export * from "./GameModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__